import type { EmbarcacaoDetailSectionProps } from "../../embarcacao-detail-section";
import { useEquipamentosSection } from "./use-equipamentos-section";
import { EquipamentosSectionView } from "./view-equipamentos-section";

export function EquipamentosSection(props: EmbarcacaoDetailSectionProps) {
  const vm = useEquipamentosSection(props);

  return <EquipamentosSectionView {...vm} />;
}

export type * from "./types-equipamentos-section";
